import gql from 'graphql-tag';

export default gql`
mutation PublishApp(
        $uuid: String!
      ) {
    publishApp(input:{
        uuid: $uuid
    }) {
      __typename
    }
}
`;
